import { gql, TypedDocumentNode } from '@apollo/client';
import { createContext } from 'react';

export const I18nContext = createContext({});

export type GetReviewsQuery = {
  reviews: Array<{
    __typename: "Review";
    id: string;
    author: string;
    text: string;
    score: number;
    publishedAt: string;
  }>;
};
type GetReviewsQueryVariables = Record<string, never>;
export const GET_REVIEWS: TypedDocumentNode<GetReviewsQuery, GetReviewsQueryVariables> = gql`
  query GetReviews($appId: ID!) {
    reviews(appId: $appId) {
      id
      author
      text
      score
      publishedAt
    }
  }
`;

export type CreateReviewMutation = {
  createReview: {
    review: {
      id: string;
      author: string;
      text: string;
      score: number;
      publishedAt: string;
    };
  } | null;
};
type CreateReviewMutationVariables = {
  review: {
    author: string;
    text: string;
    score: number;
    appId: string;
  };
};
export const CREATE_REVIEW: TypedDocumentNode<CreateReviewMutation, CreateReviewMutationVariables> = gql`
  mutation CreateReview($author: String!, $text: String!, $score: Int!, $appId: ID!) {
    createReview(input: { author: $author, text: $text, score: $score, appId: $appId }) {
      review {
        id
        author
        text
        score
        publishedAt
      }
    }
  }
`;
